export default "__VITE_ASSET__Bx3Okxgu__"